import { useAuth, useNotification } from '@/containers'
import { Dialog } from '@headlessui/react'
import { useEffect, useState } from 'react'
import CloseIcon from '../Icon/CloseIcon'
import ImageOptimize from '../ImageOptimize'

const AffiliateCongratulationPopup = () => {
  const { systemConfig } = useNotification()
  const [isOpen, setIsOpen] = useState(false)
  const { user } = useAuth()

  const handleClose = () => setIsOpen(false)

  useEffect(() => {
    if (user && localStorage.getItem('checkOpenAffiliatePopup') === '1') {
      setIsOpen(true)
      localStorage.removeItem('checkOpenAffiliatePopup')
    }
  }, [user])

  return (
    <Dialog open={isOpen} onClose={handleClose} className='relative z-[100]'>
      <Dialog.Backdrop className='bg-black/30 fixed inset-0 z-[90] bg-[#000000c5]' />
      <div className='fixed inset-0 mx-auto flex w-screen items-center justify-center p-4'>
        <Dialog.Panel className='relative h-auto w-full max-w-[370px] rounded-xl bg-white bg-memberCongraBg p-5 text-sm font-normal'>
          <ImageOptimize
            src={
              systemConfig?.companyDarkLogo || systemConfig?.companyLogo || ''
            }
            alt='logo'
            className='w-[100px]'
          />
          <button
            className='absolute right-[10px] top-[10px] border-0 outline-none'
            onClick={handleClose}
          >
            <CloseIcon className='text-main' />
          </button>
          <div className='mt-5 flex items-start justify-between'>
            <div className='w-49'>
              <p>
                Chào <strong>{user?.name || 'Hiền Nguyễn'}!</strong>
              </p>
              <p className='mt-1'>
                Chúc mừng bạn đã trở thành
                <span className='mx-1 font-semibold uppercase text-primary'>
                  đối tác
                </span>
                của Shop1 - Đa kênh Online.
              </p>
              <p className='mt-2'>
                <i>Trân trọng!</i>
              </p>
            </div>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}

export default AffiliateCongratulationPopup
